"use client";

import { c as _c } from "react/compiler-runtime";
import type { CartItemOutputDto } from "@sticker-giant/sg-frontend-common";
import { ImagePreviewDialog } from "@/components/custom/ImagePreviewDialog";
import { Button } from "@/components/ui/button";
import { getImageUrl, hasArtworkPreview } from "@/lib/cart-item-utils";
interface Props {
  item: CartItemOutputDto;
}
export function CartItemThumbnail(t0) {
  const $ = _c(10);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item) {
    t1 = getImageUrl(item);
    $[0] = item;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const thumbnailSrc = t1;
  let t2;
  if ($[2] !== item.marketingName || $[3] !== thumbnailSrc) {
    t2 = <Button variant="ghost" className="size-[100px] shrink-0 p-0 shadow-sm"><img src={thumbnailSrc} alt={item.marketingName} className="size-full rounded object-contain" /></Button>;
    $[2] = item.marketingName;
    $[3] = thumbnailSrc;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const thumbnail = t2;
  if (!hasArtworkPreview(item)) {
    return thumbnail;
  }
  let t3;
  if ($[5] !== item.artworkPage || $[6] !== item.fileBucket || $[7] !== item.fileUrl || $[8] !== thumbnail) {
    t3 = <ImagePreviewDialog bucket={item.fileBucket} filepath={item.fileUrl} title={item.fileUrl} page={item.artworkPage}>{thumbnail}</ImagePreviewDialog>;
    $[5] = item.artworkPage;
    $[6] = item.fileBucket;
    $[7] = item.fileUrl;
    $[8] = thumbnail;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}